import { getProductPrice, getPromoPrice, getValidIntCost } from '../common/common';
import { getMbpsFromPlan } from './productLabels';

export const DEFAULT_PLAN_SPEED_MBPS = 300;

// Monthly price the single-page checkout's tier buttons show for a plan - the X4Y promo price
// when there is one, otherwise the regular (servX4Y "Service" or catalog) price.
const getDisplayedMonthlyPrice = (plan, serviceTerm) =>
  getValidIntCost(getPromoPrice(plan, serviceTerm) || getProductPrice(plan, serviceTerm));

const hasX4YDiscount = (plan, serviceTerm) => Boolean(getPromoPrice(plan, serviceTerm));

const cheapest = (plans, serviceTerm) => plans.reduce((best, plan) => (
  !best || getDisplayedMonthlyPrice(plan, serviceTerm) < getDisplayedMonthlyPrice(best, serviceTerm) ? plan : best
), null);

/**
 * Plan the single-page checkout pre-selects:
 * 1. a plan with an applicable X4Y (Promo) discount - the cheapest one if several have it,
 * 2. otherwise the 300 Mbps plan,
 * 3. otherwise the lowest-priced plan.
 */
export const getDefaultPlan = (plans, serviceTerm) => {
  const candidates = (plans || []).filter(Boolean);
  if (!candidates.length) {return null;}

  const discounted = candidates.filter((plan) => hasX4YDiscount(plan, serviceTerm));
  if (discounted.length) {return cheapest(discounted, serviceTerm);}

  const defaultSpeed = candidates.filter((plan) => getMbpsFromPlan(plan) === DEFAULT_PLAN_SPEED_MBPS);
  if (defaultSpeed.length) {return cheapest(defaultSpeed, serviceTerm);}

  return cheapest(candidates, serviceTerm);
};
